import { graphql } from "@graphql-generated/gql";

export const UnreadNotificationCountGraphql = graphql(`
    query UnreadNotificationCount {
        myUnreadNotificationCount
    }
`);

export const MyNotificationsGraphql = graphql(`
    query MyNotifications($querySetting: QuerySettingInput!) {
        myNotifications(querySetting: $querySetting) {
            totalCount
            items {
                id
                finalizedAt
                itemCount
                maxSeverity
                acknowledgedAt
                items {
                    notificationType
                    sourceId
                    occurredAt
                    severity
                    payload
                }
            }
        }
    }
`);

export const AcknowledgeNotificationGraphql = graphql(`
    mutation AcknowledgeNotification($id: ID!) {
        acknowledgeNotification(id: $id) {
            id
            acknowledgedAt
        }
    }
`);

export const AcknowledgeAllNotificationsGraphql = graphql(`
    mutation AcknowledgeAllNotifications {
        acknowledgeAllNotifications
    }
`);
